module.exports = __webpack_public_path__ + "img/rules_titlebg.3066ae3e.png";